import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";

export default function UserDocumentsAdmin({ userId, onChange }) {
  const [docs, setDocs] = useState([]);
  const [form, setForm] = useState({ title: "", session_date: new Date().toISOString().slice(0, 10), file: null, notify: true });
  const [busy, setBusy] = useState(false);

  const load = useCallback(() => {
    api.get(`/admin/users/${userId}/documents`).then(({ data }) => setDocs(data.items));
  }, [userId]);
  useEffect(load, [load]);

  const upload = async (e) => {
    e.preventDefault();
    if (!form.file) { toast.error("Elige un PDF"); return; }
    const fd = new FormData();
    fd.append("file", form.file);
    fd.append("title", form.title);
    fd.append("session_date", form.session_date);
    fd.append("notify", form.notify ? "true" : "false");
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/users/${userId}/documents`, fd);
      toast.success(data.notified ? "PDF subido y aviso enviado por correo ✦" : form.notify ? "PDF subido (el correo de aviso no se pudo enviar)" : "PDF subido ✦");
      setForm({ ...form, title: "", file: null, notify: true });
      e.target.reset();
      load(); onChange();
    } catch (err) { toast.error(errMsg(err, "No se pudo subir")); }
    finally { setBusy(false); }
  };

  const remove = async (d) => {
    if (!window.confirm(`¿Quitar "${d.title}"?`)) return;
    await api.delete(`/admin/users/${userId}/documents/${d.id}`);
    load(); onChange();
  };

  return (
    <div data-testid="user-documents-admin" className="mt-5 pt-5 border-t border-white/5 space-y-4">
      <form onSubmit={upload} className="grid grid-cols-1 md:grid-cols-4 gap-3 items-end">
        <div className="md:col-span-2"><label className="field-label">Título</label>
          <input data-testid="doc-title" required className="input-field" placeholder="Ej: Sesión de Revolución Solar"
            value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} /></div>
        <div><label className="field-label">Fecha de la sesión</label>
          <input data-testid="doc-date" type="date" required className="input-field" value={form.session_date}
            onChange={(e) => setForm({ ...form, session_date: e.target.value })} /></div>
        <div><label className="field-label">PDF</label>
          <label className="btn-ghost !py-2 !px-3 text-xs inline-block cursor-pointer max-w-full truncate">
            {form.file ? form.file.name : "Elegir PDF…"}
            <input data-testid="doc-file" type="file" accept="application/pdf" className="hidden"
              onChange={(e) => setForm({ ...form, file: e.target.files?.[0] || null })} />
          </label></div>
        <label className="md:col-span-4 flex items-center gap-2 text-sm text-zinc-400">
          <input type="checkbox" data-testid="doc-notify" checked={form.notify} className="h-4 w-4 accent-[#C9A25E] cursor-pointer"
            onChange={(e) => setForm({ ...form, notify: e.target.checked })} />
          Avisar al usuario por correo
        </label>
        <button data-testid="doc-upload" disabled={busy} className="btn-lilac text-sm md:col-span-4 justify-self-start">
          {busy ? "Subiendo…" : "Subir PDF"}
        </button>
      </form>
      {docs.map((d) => (
        <div key={d.id} data-testid={`admin-doc-${d.id}`} className="flex items-center justify-between text-sm border-b border-white/5 py-2">
          <span className="text-zinc-200">{d.title} <span className="text-zinc-500">· {d.session_date} · {d.size < 1e6 ? `${Math.max(1, Math.round(d.size / 1e3))} KB` : `${(d.size / 1e6).toFixed(1)} MB`}</span></span>
          <button data-testid={`admin-doc-delete-${d.id}`} onClick={() => remove(d)} className="text-xs text-zinc-500 hover:text-red-400">Quitar</button>
        </div>
      ))}
    </div>
  );
}
